import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const InlineAlertVariant = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type InlineAlertVariantType =
  (typeof InlineAlertVariant)[keyof typeof InlineAlertVariant];

export type InlineAlertProps = {
  id?: string;
  testId?: string;
  variant?: InlineAlertVariantType;
  text?: string;
  iconName?: TUNDR_ICONS;
};

export type InlineAlertSlots = {
  default?: () => unknown;
};
